import * as React from 'react';
import { Heading, Text } from '@grandvisionhq/elements';
import { MultibancoSummary } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';

const OrderPaymentSummary = ({ paymentMethod , paymentDetails  })=>{
    const { getLabel  } = useIntl();
    const labels = {
        paymentTitle: getLabel('checkout.payment.method.title'),
        paymentMethod
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__content"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__payment"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__payment--row"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__payment--label"
    }, /*#__PURE__*/ React.createElement(Heading, {
        className: "order-payment-summary__heading",
        variant: "subheading2"
    }, labels.paymentTitle)), /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__payment--value"
    }, /*#__PURE__*/ React.createElement(Text, {
        component: "span"
    }, labels.paymentMethod))), paymentDetails && /*#__PURE__*/ React.createElement("div", {
        className: "order-payment-summary__payment--row"
    }, /*#__PURE__*/ React.createElement(MultibancoSummary, {
        result: paymentDetails
    })))));
};

export { OrderPaymentSummary };
//# sourceMappingURL=OrderPaymentSummary.js.map
